<template>
  <button-base medium="twitter" :title="i18n.t('public.social.share_on_twitter')" class="twitter"
               icon-filename="x-twitter.svg" @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import TwitterMixin from '@/share/campaign/twitter-mixin'

export default {
  components: { ButtonBase },

  mixins: [TwitterMixin]
}
</script>
